// One auditable gain contract for every subliminal lane.
//
// `0` is an authored control value and must never be treated as "missing".
// Missing, blank, or non-finite values use the documented ordinary-scene
// fallback, while every finite value is clamped to the existing lane ceiling.
//
// CEILING HISTORY: this was 0.02, which put the lane roughly 16-30 dB below the
// documented -18 dBFS design target once the x0.316 main-voice duck was applied
// (0.02 * 0.316 = 0.0063). The lane was present in the graph but inaudible in
// the ear, so the subliminal payload never reached the subject. 0.126 is the
// linear equivalent of -18 dBFS and is the value the audio design actually
// specifies. Do not lower this without a measured reason.
export const SUBLIMINAL_GAIN_CEILING = 0.126;

function numericGain(value) {
  if (value === null || value === undefined) return Number.NaN;
  if (typeof value === "string" && value.trim() === "") return Number.NaN;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : Number.NaN;
}

export function clampSubliminalGain(value, fallback = 0) {
  const numeric = numericGain(value);
  const fallbackNumeric = numericGain(fallback);
  const selected = Number.isFinite(numeric)
    ? numeric
    : Number.isFinite(fallbackNumeric)
      ? fallbackNumeric
      : 0;
  return Math.max(0, Math.min(SUBLIMINAL_GAIN_CEILING, selected));
}

export function resolveSubliminalGain(
  scene = {},
  { background = false, fallback = SUBLIMINAL_GAIN_CEILING } = {},
) {
  const requested = background ? scene?.backgroundSubliminalLevel : scene?.subliminalLevel;
  return clampSubliminalGain(requested, fallback);
}

export function resolveDuckedSubliminalGain(baseGain, mainVoiceActive = false) {
  const gain = clampSubliminalGain(baseGain, 0);
  return gain * (mainVoiceActive ? 0.316 : 1);
}
